import { Company } from '../../../services/company.service';

export interface NavLink {
  label: string;
  route: string;
  /** Lucide icon name, shown in the mobile navigation. */
  icon: string;
  /** Omitted means: always visible. */
  isVisible?: (company: Company) => boolean;
}

/**
 * Single source of truth for the main navigation — rendered by both the
 * desktop bar and the mobile sheet.
 */
export const MAIN_NAV_LINKS: NavLink[] = [
  { label: 'Gutscheine', route: '/voucher-dashboard', icon: 'lucideTickets' },
  {
    label: 'Zahlungen',
    route: '/financial-dashboard',
    icon: 'lucideWallet',
    isVisible: (company) => !company.is_member,
  },
  // Members have no Stripe account: their network pays them by monthly settlement.
  {
    label: 'Auszahlungen',
    route: '/payouts',
    icon: 'lucideBanknote',
    isVisible: (company) => !!company.is_member,
  },
  {
    label: 'Produkte',
    route: '/products',
    icon: 'lucidePackage',
    isVisible: (company) => !company.is_member,
  },
  { label: 'Einstellungen', route: '/settings', icon: 'lucideSettings' },
];
